/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getRecommendations.defs.js";
export { main as default } from "./getRecommendations.defs.js";
